import { MediaAssetTabs, MediaAssetsViewOptions, MediaKind } from "../../../types";
import { StockAssets } from "./features/StockAssets";
import { UploadedMediaAssets } from "./features/UploadedMediaAssets";
// TODO: re-enable once we know which asset library holds the project's
// generated videos (need to confirm with backend).
// import { AIGeneratedVideos } from "./features/AIGeneratedVideos";
import { useTemplateData } from "../../../hooks/useTemplateData";

export const VideosTab = ({
  previewWidth,
  previewHeight,
  mediaAssetTabView,
  onReplaceSelectedAsset,
  customAddToCanvas,
  selectionMode,
}: {
  previewWidth: number;
  previewHeight: number;
  mediaAssetTabView: MediaAssetsViewOptions;
  onReplaceSelectedAsset?: (
    assetId: string,
    path: string,
    mediaType: MediaKind
  ) => void;
  customAddToCanvas?: (assetId: string, path: string) => void;
  selectionMode?: boolean;
}) => {
  const {
    templatesData: { organizationId },
    assetLibrariesData: { organizationAssetLibraries },
  } = useTemplateData();

  const organizationAssetLibraryId = organizationAssetLibraries[0]?.id;

  if (!organizationAssetLibraryId) return null;

  const galleryProps = {
    onReplaceSelectedAsset,
    customAddToCanvas,
    selectionMode,
  };

  return (
    <>
      {mediaAssetTabView === MediaAssetsViewOptions.Stock && (
        <StockAssets
          assetLibraryId={organizationAssetLibraryId}
          previewWidth={previewWidth}
          previewHeight={previewHeight}
          mediaAsset={MediaAssetTabs.Videos}
          {...galleryProps}
        />
      )}
      {mediaAssetTabView === MediaAssetsViewOptions.Uploads &&
        organizationId && (
          <UploadedMediaAssets
            organizationId={organizationId}
            assetLibraryId={organizationAssetLibraryId}
            previewWidth={previewWidth}
            previewHeight={previewHeight}
            mediaAsset={MediaAssetTabs.Videos}
            {...galleryProps}
          />
        )}
      {/* TODO: re-enable once we know which asset library holds the project's
          generated videos (need to confirm with backend).
      {mediaAssetTabView === MediaAssetsViewOptions.AIGenerated &&
        organizationAssetLibraryId && (
          <AIGeneratedVideos
            assetLibraryId={organizationAssetLibraryId}
            previewWidth={previewWidth}
            previewHeight={previewHeight}
          />
        )}
      */}
    </>
  );
};
